var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightGreenShrub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215.664,
    height: 205.263,
    viewBox: "0 0 215.664 205.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8,0,0,54.328,30.943,168.546s18.963-14.287,112.54-27.479l38.943-28.852L172.237,77.247l-21.921-51.87Z",
    transform: "translate(0 -11.562)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.974, -0.225, 0.225, 0.974, 2.601, 52.302)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.683,76.047c.567-13.906,1.95-27.932,6.452-41.1A62.07,62.07,0,0,1,62.788,13.969c4.6-5.23,12.72-12.179,20.276-10.759C95.959,5.632,95.592,25.241,95.428,34.934c-.675,39.652-11.454,76.556-27.29,111.077-.646,1.409-2.995,7.129-3.653,8.531l-17.309,3.9c-1.421-24.354-3.486-58.017-2.493-82.393",
    transform: "translate(14.395 0.979)",
    fill: "#91ba45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.013,127c3.8-17.185,14.673-43.828,23.813-58.871C95.1,52.858,105.9,38.1,121.511,28.807c2.431-1.449,5.668-2.2,8.013-.612,6.521,4.41,1.719,18.558.069,24.443-2.257,8.049-5.932,15.614-9.644,23.07a335.179,335.179,0,0,1-40.333,62.474l-17.04,17.53c-2.8-12.285-3.378-16-.563-28.713",
    transform: "translate(19.497 8.849)",
    fill: "#91ba45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,50.628c.22-2.961.613-6,2.083-8.582,4.376-7.687,11.076-3.51,15.132,1.656C38.558,57.513,46.2,73.272,52.838,89.443a265.7,265.7,0,0,1,16.122,56.211L56.121,161.481C43.407,145.5,31.464,128.729,22.867,110.208,14.287,91.726,8.983,71.112,10.5,50.628",
    transform: "translate(3.319 12.255)",
    fill: "#91ba45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.771,90.294c5.029-5.015,12.447-12.725,18.342-16.683,5.629-3.779,13.37-9.6,20.212-10.5,5.954-.777,8.925,3.979,8.438,9.39-.56,6.212-3.979,11.877-7.938,16.536-14.314,16.85-37.088,26.449-56.886,35.225l-3.748-1.3c5.4-13.374,11.35-22.468,21.581-32.672",
    transform: "translate(24.365 20.425)",
    fill: "#91ba45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3,82.7c5.227,11.787,8.582,24.472,11.058,37.1.086.438.757.253.671-.185C53.54,106.92,50.154,94.19,44.9,82.345c-.181-.409-.781-.056-.6.351",
    transform: "translate(14.344 26.625)",
    fill: "#91ba45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.464,124.892A180.818,180.818,0,0,1,78.512,71.725q3.805-7.055,8.136-13.806c.241-.379-.36-.728-.6-.352a195.723,195.723,0,0,0-23.56,51.313q-2.234,7.819-3.694,15.826c-.079.438.591.626.671.185",
    transform: "translate(19.049 18.602)",
    fill: "#91ba45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.637,118.667a233.371,233.371,0,0,0,33.271-41.6c.242-.38-.361-.73-.6-.352a232.471,232.471,0,0,1-33.162,41.456c-.32.315.172.806.493.493",
    transform: "translate(23.668 24.808)",
    fill: "#91ba45"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightGreenShrub);
export default __webpack_public_path__ + "static/media/light-green-shrub.2f3180fa68b6380b175ca68c04c15e0e.svg";
export { ForwardRef as ReactComponent };